import { Link, useNavigate } from "react-router-dom";
import { useObserver } from "mobx-react";
import AuthStore from "../../stores/AuthStore";
import { useQueryClient } from "@tanstack/react-query";
import { ThemeToggle } from "../ui/theme-toggle";

export function NavbarAdmin() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const adminRoutesMenu = [
    {
      displayName: "Kullanıcılar",
      path: "/admin/users",
      isHavePermission: AuthStore.isHavePermission("Permission_UserRead"),
    },
    {
      displayName: "Roller",
      path: "/admin/roles",
      isHavePermission: AuthStore.isHavePermission("Permission_RoleRead"),
    },
    {
      displayName: "GPT Prompt'ları",
      path: "/admin/gptprompts",
      isHavePermission: AuthStore.isHavePermission("Permission_SuperAdmin"),
    },
    {
      displayName: "Ayarlar",
      path: "/admin/settings",
      isHavePermission: AuthStore.isHavePermission("Permission_SuperAdmin"),
    },
  ];
  const logout = () => {
    // localstorage  must be clear in here
    queryClient.clear();
    AuthStore.logout();
    navigate("/");
  };
  return useObserver(() => (
    <nav className="bg-card text-muted-foreground w-64 p-6 border-r">
      <div className="flex  flex-col  justify-between h-full">
        <div className="space-y-6">
          <div className="flex items-center justify-between">
            <Link
              className="flex items-center gap-2 text-lg font-semibold text-foreground"
              to="/admin"
            >
              <span>NewTurk PORTAL</span>
            </Link>
            <ThemeToggle />
          </div>
          <div className="space-y-4">
            {adminRoutesMenu.map(
              (route) =>
                route.isHavePermission && (
                  <Link
                    className="flex items-center gap-2 hover:text-foreground transition-colors"
                    to={route.path}
                    key={route.path}
                  >
                    {route.displayName}
                  </Link>
                )
            )}
          </div>
        </div>

        <div className="space-y-4">
          <Link
            className="flex items-center gap-2 hover:text-foreground transition-colors"
            to="/dashboard"
            href="#"
          >
            <span>Admin'den Çık</span>
          </Link>
          <Link
            className="flex items-center gap-2 hover:text-foreground transition-colors"
            onClick={logout}
            href="#"
          >
            <span>Oturumu Kapat</span>
          </Link>
        </div>
      </div>
    </nav>
  ));
}
